import { createBrowserHistory } from 'history';

// Vite injects BASE_URL from the build's `--base` flag ('/' by default, '/admin/' on the IDP
// golden path where this SPA is served under veritas.<env>/admin/*). history wants it without
// the trailing slash; an empty basename is the same as none (legacy builds unchanged).
const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

export const history = createBrowserHistory(basename ? { basename } : undefined);